<template>
    <header class="page-header">
        
    
        <div class="container">
            <!-- <div class="slg-video">

            <div class="video-box">
                <iframe id="player" src="https://www.youtube.com/embed/-2WQ43jK1HA?rel=0&autoplay=1&loop=1&enablejsapi=1&playsinline=1&controls=1" frameborder="0" allowfullscreen>
                </iframe>
                <button id="play">play</button>
            </div>
                
            </div> -->
            
            <div class="row">
                <div class="col-12">
                    <div class="top-banner-wrap">
                        
                        <img :src="slogan" alt="">
                    </div>
                </div>
            </div>
            
        </div>
    </header>
</template>
<script>

import slogan from '../assets/slogan.png';



export default {
    data(){
        return {
            slogan
        }
    }
}

</script>

<style lang="sass">

.page-header
    padding-top: 200px
    padding-bottom: 50px
    z-index: 1000
    @media (max-width: 1440px)
        padding-top: 180px
    @media (max-width: 991px)
        padding-top: 120px
    @media (max-width: 768px)
        padding-top: 60px
        padding-bottom: 50px
    @media (max-width: 576px)
        padding-top: 40px
        padding-bottom: 30px
    .top-banner-wrap
        text-align: center
        img
            width: 85%
            max-width: 900px
            @media (max-width: 576px)
                // width: 100%
                // max-width: auto



</style>


// WEBPACK FOOTER //
// src/subview/PageHeader.vue